import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { isRetryableError } from '@shared/api/errors';
import { Outlet } from 'react-router-dom';
import { ToastContainer, cssTransition } from 'react-toastify';
import { AuthModalContextProvider } from './context/AuthModalContext';
import { DrawerContextProvider } from './context/DrawerContext';
import { OfferCheckoutContextProvider } from './context/OfferCheckoutContext';
import { PlaidContextProvider } from './context/PlaidContext';
import { UserContextProvider } from './context/UserContext';
import { ScrollToTop } from './components/ScrollToTop';
import { AuthModalsContainer } from './modal/AuthModalsContainer';
import { DocumentTheme } from './DocumentTheme';
import { FeatureFlagContextProvider } from './featureFlags';
import 'react-toastify/dist/ReactToastify.css';
import './Toast.overrides.css';
import '../index.scss';

const MAXIMUM_RETRIES = 3;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        return isRetryableError(error) && failureCount < MAXIMUM_RETRIES;
      },
    },
  },
});

const extraContainerProps = process.env.OPTIMIZED_FOR_E2E
  ? {
      transition: cssTransition({
        enter: 'noop',
        exit: 'noop',
        collapse: false,
      }),
    }
  : {};

export const Root = () => (
  <FeatureFlagContextProvider>
    <DocumentTheme />
    <QueryClientProvider client={queryClient}>
      <UserContextProvider>
        <OfferCheckoutContextProvider>
          <AuthModalContextProvider>
            <DrawerContextProvider>
              <PlaidContextProvider>
                <Outlet />
                <ScrollToTop />
                <ToastContainer
                  position="top-right"
                  autoClose={false}
                  newestOnTop
                  limit={1}
                  closeButton
                  hideProgressBar
                  pauseOnHover
                  theme="colored"
                  {...extraContainerProps}
                />
              </PlaidContextProvider>
            </DrawerContextProvider>
            <AuthModalsContainer />
          </AuthModalContextProvider>
        </OfferCheckoutContextProvider>
      </UserContextProvider>
    </QueryClientProvider>
  </FeatureFlagContextProvider>
);
